import classNames from 'classnames';
import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslate } from '../mixins/translate/translate';
import { usePatchedDropdownMenu } from '../utils/usePatchedDropdownMenu';

type Props = {
    isTempLogin: boolean;
    isSsoLogin: boolean;
    firstName: string;
    lastName: string;
};

export function UserProfileDropdown(props: Props) {
    const navigate = useNavigate();
    const translate = useTranslate();
    const isRegularUserLoggedIn = !(props.isTempLogin || props.isSsoLogin);
    const menuItemsAmount = isRegularUserLoggedIn ? 2 : 1;
    const { buttonProps, itemProps, isOpen, setIsOpen } = usePatchedDropdownMenu(menuItemsAmount);
    const classes = classNames('dropdown menu-merge', { open: isOpen });

    const getTitleForMenu = () => (isRegularUserLoggedIn ? `${props.firstName} ${props.lastName}` : translate('common.logout'));

    const profileClickHandler = () => {
        setIsOpen(false);
        navigate('/profile');
    };

    const getRegularUserMenuItems = () => (
        <>
            <li {...itemProps[0]}>
                <a className="cursor" onClick={profileClickHandler}>
                    <span className="fa fa-user p5" />
                    {translate('common.profile')}
                </a>
            </li>
            {getLogOutMenuItem(1)}
        </>
    );

    const getLogOutMenuItem = (index: number) => (
        <li {...itemProps[index]}>
            <a href="/api/session/logout">
                <span className="fa fa-power-off p5" />
                {translate('common.logout')}
            </a>
        </li>
    );

    return (
        <li className={classes}>
            <a {...buttonProps} className="dropdown-toggle fw800 cursor" data-toggle="dropdown" role="button">
                <span className="pl10">{getTitleForMenu()}</span>
                <span className="caret caret-tp hidden-xs" />
            </a>
            <ul className="dropdown-menu list-group animated animated-short fadeIn w100" role="menu">
                {isRegularUserLoggedIn ? getRegularUserMenuItems() : getLogOutMenuItem(0)}
            </ul>
        </li>
    );
}
